import $http from "./http";
import config from "./config";

/**
 * @class 授权信息
 * @classdesc 授权信息对象
 * @desc 授权信息描述
 */
var ConferInfo = {
  /**
   * @desc 授予人编号
   */
  RoleID: "",
  /**
   * @desc 授予类型
   */
  RoleWith: 1311,
  /**
   * @desc 授权人编号
   */
  OwnerID: "",
  /**
   * @desc 授权类型
   */
  OwnerWith: 1311,
  /**
   * @desc 空间编号
   */
  SpaceID: "",
  /**
   * @desc 授予日期
   */
  ConferDate: new Date(),
  /**
   * @member {Date} 过期日期
   */
  ExpiryDate: "2018-12-04 09:00:00", //过期日期
};

export default {
  name: "system",

  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  login(loginInfo) {
    return $http.post(this.getUrl("/Security/Login"), loginInfo);
  },
  logout() {
    return $http.post(this.getUrl("/Security/Logout"), "");
  },
  getTicketInfo(options) {
    return $http.post(this.getUrl("/Security/GetTicketInfo"), "", options);
  },
  register(data) {
    return $http.post(this.getUrl("/Security/Register"), data);
  },
  saveSupplier(data) {
    return $http.post(this.getUrl("/Security/saveSupplier"), data);
  },
  getSiteInfo() {
    return $http.get(this.getUrl(`/Security/GetSiteInfo`));
  },
  sendValidCode(data) {
    return $http.post(this.getUrl(`/Security/SendValidCode`), data);
  },
  checkAccount(data) {
    return $http.post(this.getUrl(`/Security/CheckAccount`), data);
  },
  sendCode(data) {
    return $http.post(this.getUrl(`/Security/SendCode`), data);
  },
  checkCode(data) {
    return $http.post(this.getUrl(`/Security/checkCode`), data);
  },
  resetPwd(data) {
    return $http.post(this.getUrl("/Security/ResetPwd"), data);
  },
  getUserActions(options) {
    return $http.get(this.getUrl(`/Security/getUserActions`), options);
  },
  getMobileUser(mobile) {
    return $http.get(this.getUrl(`/Security/GetMobileUser?mobile=${mobile}`));
  },
  authSendCode(data) {
    /**
     * @method 将验证码发送到邮箱或手机号
     **/

    //  data = {
    //     ValidID: '3BD080AACE894C428776377B13FD6C7D',//图形验证码的编号
    //     ValidCode: 'mxzri',//图形验证码的值
    //     UserAct: '13167016166',//需要绑定的手机号
    //     UserID: 'S00000295701',//需要绑定的用户编号
    //     AuthType: '10222',//绑定方式
    // }
    return $http.post(this.getUrl(`/auth/SendCode`), data);
  },
  authBind(data) {
    /**
     * @method 绑定手机或邮箱
     */

    // data = {
    //     ValidID: '3BD080AACE894C428776377B13FD6C7D',//authSendCode 返回的绑定验证编号
    //     ValidCode: 'mxzri',//用户输入的验证码
    // }
    return $http.post(this.getUrl(`/auth/Bind`), data);
  },
  getAccountList(data) {
    return $http.post(this.getUrl("/UserAccount/List"), data);
  },
  initializePassword(data) {
    return $http.post(this.getUrl("/UserAccount/InitializePassword"), data);
  },
  getAccountInfo(UserAct) {
    return $http.get(this.getUrl(`/UserAccount/Details?UserAct=${UserAct}`));
  },
  getNameList(data, tip) {
    return $http.post(this.getUrl("/RoleInfo/NameList"), data, tip);
  },
  getRoleList(data, tip) {
    return $http.post(this.getUrl("/RoleInfo/List"), data, tip);
  },
  getRoleInfo(data, options) {
    return $http.post(this.getUrl("/RoleInfo/Details"), data, options);
  },
  saveRoleInfo(data) {
    return $http.post(this.getUrl("/RoleInfo/Update"), data);
  },
  getConsumers(data) {
    return $http.post(this.getUrl("/RoleInfo/getConsumers"), data);
  },
  deleteRoleInfo(id, spaceID, ownerType) {
    return $http.get(this.getUrl(`/RoleInfo/Delete/${id}?spaceID=${spaceID}&ownerType=${ownerType}`));
  },
  getRoleOwners(data) {
    return $http.post(this.getUrl(`/RoleInfo/GetRoleOwners`), data);
  },
  getConferList(data) {
    return $http.post(this.getUrl(`/ConferInfo/List`), data);
  },
  getConferInfo(data) {
    /**
     * @method 获取授权信息
     */
    // data = {
    //     RoleID: 'S000000000',//获得权限的人
    //     RoleWith: '1311',//获得权限的人
    //     OwnerID: 'S000000000',//获得权限的人
    //     OwnerWith: '1311',//获得权限的人
    //     SpaceID: 'S000000000',//获得权限的人
    //     ConferDate: '2018-12-04 09:00:00',//授予日期
    //     ExpiryDate: '2018-12-04 09:00:00',//过期日期
    // }
    return $http.post(this.getUrl(`/ConferInfo/Details`), data);
  },
  /**
   * @method 保存授权信息
   * @param {ConferInfo} [data] conferInfo对象
   */
  saveConferInfo(data) {
    return $http.post(this.getUrl(`/ConferInfo/Save`), data);
  },
  deleteConferInfo(data) {
    return $http.post(this.getUrl(`/ConferInfo/Delete`), data);
  },
  UpdateSuperUser(UserID) {
    return $http.get(this.getUrl(`/ConferInfo/UpdateSuperUser?UserID=${UserID}`));
  },

  getConferService(data) {
    return $http.post(this.getUrl(`/ConferInfo/GetConferService`), data);
  },

  getServiceList(companyID) {
    return $http.get(this.getUrl(`/ConferInfo/GetServiceList?companyID=${companyID}`));
  },

  disptachService(companyID, serviceID) {
    return $http.get(this.getUrl(`/ConferInfo/DisptachService?customerID=${companyID}&serviceID=${serviceID}`));
  },
  revokeService(companyID, serviceID) {
    return $http.get(this.getUrl(`/ConferInfo/RevokeService?customerID=${companyID}&serviceID=${serviceID}`));
  },

  getFlowList(data) {
    return $http.post(this.getUrl(`/FlowInfo/List`), data);
  },
  getFlowInfo(FlowID) {
    return $http.get(this.getUrl(`/FlowInfo/Details/${FlowID}`),{failTips:false});
  },
  saveFlowInfo(data) {
    return $http.post(this.getUrl(`/FlowInfo/Update`), data);
  },
  deleteFlowInfo(FlowID) {
    return $http.get(this.getUrl(`/FlowInfo/Delete/${FlowID}`));
  },

  getContactList(data) {
    return $http.post(this.getUrl(`/ContactInfo/List`), data);
  },
  getContactInfo(ContactID) {
    return $http.get(this.getUrl(`/ContactInfo/Details/${ContactID}`));
  },
  saveContactInfo(data) {
    return $http.post(this.getUrl(`/ContactInfo/Update`), data);
  },
  deleteContactInfo(ContactID) {
    return $http.get(this.getUrl(`/ContactInfo/Delete/${ContactID}`));
  },

  getInvoiceList(data) {
    return $http.post(this.getUrl(`/InvoiceInfo/List`), data);
  },
  getInvoiceInfo(InvoiceID) {
    return $http.get(this.getUrl(`/InvoiceInfo/Details/${InvoiceID}`));
  },
  saveInvoiceInfo(data) {
    return $http.post(this.getUrl(`/InvoiceInfo/Update`), data);
  },
  deleteInvoiceInfo(InvoiceID) {
    return $http.get(this.getUrl(`/InvoiceInfo/Delete/${InvoiceID}`));
  },

  getConfigInfoList(data) {
    return $http.post(this.getUrl(`/ConfigInfo/list`), data);
  },
  getConfigInfoUpdate(data) {
    return $http.post(this.getUrl(`/ConfigInfo/Update`), data);
  },

  getMessageList(data) {
    return $http.post(this.getUrl(`/MessageTemplate/list`), data);
  },
  getMessageStatus(id) {
    return $http.get(this.getUrl(`/MessageTemplate/MessageStatus/${id}`));
  },
  getMessageDetail(id) {
    return $http.get(this.getUrl(`/MessageTemplate/Details/${id}`));
  },
  getMessageSave(data) {
    return $http.post(this.getUrl(`/MessageTemplate/MessageSave`), data);
  },
  saveConfigInfo(data) {
    return $http.post(this.getUrl(`configinfo/ConfigInfoSave`), data);
  },
  getConfigInfoLists(data) {
    return $http.post(this.getUrl(`configinfo/ConfigInfoList`), data);
  },
  getCompanyConfigs(data) {
    return $http.post(this.getUrl(`configinfo/CompanyConfigs`), data);
  },
  getClearRoleInfo(data) {
    return $http.get(this.getUrl(`/RoleInfo/ClearRoleInfo?SpaceID=${data.SpaceID}&RoleName=${data.RoleName}`));
  },
  getOwners(data) {
    return $http.post(this.getUrl("/RoleInfo/Owners"), data);
  },
  subscribe(supplyid, serviceid) {
    return $http.get(this.getUrl(`/RoleInfo/subscribe?SupplyID=${supplyid}&ServiceID=${serviceid}`));
  },
  //   addServices(id) {
  //     return $http.get(this.getUrl(`/ConfigInfo/AddServiceInfo?CompanyID=${id}`));
  //   },
  getUserinfoDetails() {
    return $http.post(this.getUrl("/userinfo/details"));
  },
  saveUserinfo(data) {
    return $http.post(this.getUrl("/userinfo/save"), data);
  },
  getInviteInfo(inviteCode) {
    return $http.get(this.getUrl(`/security/InviteInfo?inviteCode=${inviteCode}`));
  },
  getInviteMatch(targetId,deptId,activeCode) {
    return $http.post(this.getUrl(`/InviteInfo/match?targetId=${targetId}&deptId=${deptId}&activeCode=${activeCode}`), {});
  },
  saveInviteInfo(data) {
    return $http.post(this.getUrl("/InviteInfo/save"), data);
  },
  inviteNotify(data) {
    return $http.post(this.getUrl(`/InviteInfo/notify`), data);
  },
  activate(data) {
    return $http.post(this.getUrl("/security/activate"), data);
  },
  SMSCode(data) {
    return $http.post(this.getUrl("/security/SMSCode"), data);
  },
  approval(data) {
    return $http.post(this.getUrl("/roleInfo/approval"), data);
  },
  getCompanyExtra(data) {
    return $http.post(this.getUrl("/extrainfo/SearchExtraInfo"), data ,{
      failTips: false
  });
  },
  saveCompanyExtra(data){
    return $http.post(this.getUrl("/extrainfo/Save"), data);
  }
};



// WEBPACK FOOTER //
// ./src/apis/systemApis.js